import styled from 'styled-components';

export const ProgressWrapper = styled.label`
  position: relative;
  width: 100%;
`;

export const ProgressIndicator = styled.span`
  position: absolute;
  top: 50%;
  right: 0.2em;
  display: block;
  padding: 0.2em;
  background-color: var(--color-sleepunique-teal);
  color: var(--color-sleepunique-light-red);
  font-family: 'Stag Sans';
  font-size: 0.75rem;
  font-weight: 300;
  line-height: 1;
  transform: translateY(-50%);
`;

export const Progress = styled.div`
  width: 100%;
  height: 1.25rem;
  border: 1px solid var(--color-sleepunique-light-red);
`;

export const ProgressInner = styled.div`
  height: 100%;
  background-color: var(--color-sleepunique-light-red);
  transition: width 100ms ease-in-out;
`;
